import { Cloud, Code, Database, GitBranch, Zap, TrendingUp, Github, Linkedin } from 'lucide-react';
import { Experience, Skill, Achievement, ContactInfo, Social } from '@/types';

export const contactInfo: ContactInfo = {
  phone: "(760) 405-4985",
  email: "stephenwolfe1@gmail.com",
  location: "Philadelphia, PA"
};

export const experiences: Experience[] = [
  {
    company: "Kandji",
    location: "Miami, FL (Remote)",
    role: "Principal Infrastructure Engineer",
    period: "January 2022 - PRESENT",
    highlights: [
      "Lead architect for critical infrastructure technologies including Kubernetes, Terraform, AWS, GCP, and Kafka",
      "Redesigned core systems supporting customer-facing applications while reducing costs by 30%",
      "Spearheaded cloud cost optimization initiative saving over $500K annually",
      "Built resilient Kubernetes clusters with zero-downtime upgrade capabilities"
    ]
  },
  {
    company: "Ghost Managment",
    location: "Irvine, CA (Remote)",
    role: "Staff DevOps Engineer",
    period: "December 2018 - January 2022",
    highlights: [
      "Led design and implementation of all cloud infrastructure",
      "Migrated applications from Rancher to Kubernetes with blue/green deployment strategies",
      "Transitioned CI/CD pipelines to GitOps model with Vault integration",
      "Provided technical leadership and mentorship to development teams"
    ]
  },
  {
    company: "Spireon",
    location: "Irvine, CA",
    role: "Senior DevOps Engineer",
    period: "April 2018 - December 2018",
    highlights: [
      "Designed new Kubernetes environment for Docker Swarm migration",
      "Stabilized production Elasticsearch cluster and containerized telemetry pipeline",
      "Created custom Helm charts and maintained CI/CD capabilities during migrations"
    ]
  },
  {
    company: "Dealersocket",
    location: "San Clemente, CA",
    role: "IT Systems Architect",
    period: "October 2011 - April 2018",
    highlights: [
      "Designed infrastructure systems and defined technology roadmap",
      "Championed DevOps principles across R&D teams",
      "Implemented automated CI/CD pipelines and Docker standards"
    ]
  }
];

export const skills: Skill[] = [
  { name: "Kubernetes", icon: Cloud, category: "Orchestration" },
  { name: "Terraform", icon: Code, category: "IaC" },
  { name: "AWS", icon: Cloud, category: "Cloud" },
  { name: "GCP", icon: Cloud, category: "Cloud" },
  { name: "Kafka", icon: Database, category: "Data" },
  { name: "GitOps", icon: GitBranch, category: "DevOps" },
  { name: "CI/CD", icon: Zap, category: "DevOps" },
  { name: "MLOps", icon: TrendingUp, category: "ML" },
  { name: "Golang", icon: Code, category: "Languages" },
  { name: "Python", icon: Code, category: "Languages" },
];

export const achievements: Achievement[] = [
  { metric: "30%", description: "Cloud cost reduction while supporting growth" },
  { metric: "$500K+", description: "Annual savings from SaaS audit optimizations" },
  { metric: "Zero", description: "Downtime deployments with resilient K8s clusters" },
  { metric: "Multi-region", description: "Highly available application architecture" }
];

export const socials: Social[] = [
  { link: "https://www.linkedin.com/in/stephen-wolfe-1b21962b", icon: Linkedin },
  { link: "https://github.com/stephenwolfe1", icon: Github },
];